;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionNumeric', {
    controller: Controller,
    templateUrl: 'survey-question-numeric.html',
    bindings: {
      survey: '=',
      question: '=',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this
    ctrl.MAX_SLIDER_CHOICES = 20

    ctrl.$onInit = onInit

    function onInit() {
      ctrl.selected = ctrl.question.selected[0]
    }
  }
})()
